import axios from "axios";

// 通用请求方法
class ApiClient {
  async getMock() {
    return true;
  }

  async get(url) {
    return await axios.get(url, {});
  }

  async post(url, data) {
    return await axios.post(url, data);
  }
}

/**
 * 启用真实数据的一键式配置
 */
export const WHOLE_USE_MOCK = false;
export const apiClient = new ApiClient();
